const ContactType = [

    {value: "", label: "Choose"},
    {value: "Cell", label: "Cell"},
    {value: "Home", label: "Home"},
    {value: "Work", label: "Work"},
    {value: "Other", label: "Other"}
                                            
]

export default ContactType;


// WEBPACK FOOTER //
// ./src/components/Common/ContactType.js